import React from 'react'
import {connect} from 'react-redux'
import axios from 'axios'
import {Dialog, LoadMore} from 'react-weui'

import {isLZWKAPP, removeAds} from '../utils'
import {Page, InfiniteScroll, WKVisible} from '../components'

import banner from '../images/lecture/share-banner-new.png'
import '../css/page/LectureShareRankPage.css'


class ChannelShareRankPage extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            isShowDialog: false,
            ranks: null,
            ranksOffset: 0,
            ranksHasMore: true,
            isRanksAsking: false,
            myRank: null,
            selectedUid: '',
            detailList: null,
            detailOffset: 0,
            isDetailListAsking: false,
            detailListHasMore: true,
            isReturniOSError: false,
        }
    }

    componentDidMount() {
        document.title = '人气榜'

        const id = +this.props.params.id
        if (id === 0) {
            this.setState({isReturniOSError: true})
        } else {
            this.fetchRankList()
        }
    }

    fetchRankList() {
        this.setState({isRanksAsking: true})
        axios.get(`/api/channel/${this.props.params.id}/sharerank/list?offset=${this.state.ranksOffset}`)
            .then(res => {
                this.setState({
                    ranks: (this.state.ranks || []).concat(res.data.data.list_data),
                    ranksOffset: res.data.data.next_offset,
                    ranksHasMore: res.data.data.has_more,
                    isRanksAsking: false,
                    myRank: res.data.data.my_rank
                })
            })
    }

    fetchRankDetail(id) {
        this.setState({isDetailListAsking: true})
        axios.get(`/api/channel/${this.props.params.id}/sharerank/${id}/detail?offset=${this.state.detailOffset}`)
            .then(res => {
                this.setState({
                    detailList: (this.state.detailList || []).concat(res.data.data.accounts),
                    detailOffset: res.data.data.next_offset,
                    isDetailListAsking: false,
                    detailListHasMore: res.data.data.has_more,
                })
            })
    }

    onClickRank(id) {
        this.setState({isShowDialog: true, selectedUid: id})
        this.fetchRankDetail(id)
    }

    renderRank(item, index) {
        return (
            <div key={index} className="weui-flex item-padding rank-item"
                 onClick={() => this.onClickRank(item.id)}>
                <div className="weui-flex__item flex_2">
                    <div className="portrait">
                        <img src={item.avatar}/>
                    </div>
                </div>
                <div className="weui-flex__item flex_10">
                    <p className='big-font'>{index + 1}. {removeAds(item.name)}</p>
                    <p className="text-minor">带了<span className="key-num">{item.total}</span>个朋友来听课</p>
                </div>
            </div>
        )
    }

    handleClickDialogClose() {
        this.setState({isShowDialog: false, detailList: null, detailOffset: 0})
    }

    renderRanks(ranks) {
        if (!ranks) return <LoadMore loading></LoadMore>
        return ranks.map((item, index) => this.renderRank(item, index))
    }

    handleTouchBottom() {
        this.fetchRankDetail(this.state.selectedUid)
    }

    handleTouchRanksBottom() {
        this.fetchRankList()
    }

    toShareCardPage() {
        const channelId = +this.props.params.id
        if (!isLZWKAPP()) return window.location = `/channel/${channelId}/sharecard`
        switch (window.systemType) {
            case 'android':
                WKApp.toShareCardPage("channel", channelId)
                break
            case 'ios':
                window.webkit.messageHandlers.WKApp.postMessage({
                    function: "toShareCardPage",
                    type: "channel",
                    id: channelId,
                })
                break
            default:
                window.location = `/channel/${channelId}/sharecard`
        }
    }

    render() {
        if (this.state.isReturniOSError) {
            return (
                <Page>
                    <div className="wk-inner-page lecture-share-rank-page">
                        <p className="wk-center " style={{padding: "0 20px", fontSize: "16px"}}>
                            iOS版本课程人气榜在维护中，将在两天内更新版本开放。请在微信端查看。给您造成不便，深感抱歉。
                        </p>
                    </div>
                </Page>
            )
        } else {
            return (
                <Page>
                    <div className="wk-inner-page lecture-share-rank-page">
                        <a className="header" onClick={() => this.toShareCardPage()}>
                            <img src="https://static-1253442168.file.myqcloud.com/xupload/20220402_9u00877.png" alt=""/>
                        </a>
                        <Me account={this.props.account} myRank={this.state.myRank} channelId={this.props.params.id}
                            toShareCardPage={() => this.toShareCardPage()}
                        />
                        <div className="rank-list">
                            {this.renderRanks(this.state.ranks)}
                        </div>
                        <div className="detail-list">
                            <Dialog type="ios" title='邀请成员列表' show={this.state.isShowDialog} buttons={[{
                                label: '关闭',
                                onClick: () => this.handleClickDialogClose()
                            }]}>
                                <DetailList
                                    list={this.state.detailList}
                                    handleTouchBottom={() => this.handleTouchBottom()}
                                    isDetailListAsking={this.state.isDetailListAsking}
                                    detailListHasMore={this.state.detailListHasMore}
                                />
                            </Dialog>
                            {this.state.isRanksAsking && <LoadMore loading></LoadMore>}
                        </div>
                        <InfiniteScroll
                            onTouchBottom={() => this.handleTouchRanksBottom()}
                            distance={100}
                            isStop={this.state.isRanksAsking}
                            isKill={!this.state.ranksHasMore}
                        />
                    </div>
                </Page>
            )
        }
    }
}


function Me(props) {
    const myRank = props.myRank
    return (
        <div className="me-box">
            <div className="weui-flex item-padding">
                <div className="weui-flex__item flex_2">
                    <div className="portrait">
                        <img src={props.account.small_avatar_url} alt=""/>
                    </div>
                </div>
                <div className="weui-flex__item flex_6 padding-line">
                    <p className='big-font'>我</p>
                    <WKVisible create={!myRank}>
                        <p className="text-minor">还没带朋友来一起听课哦</p>
                    </WKVisible>
                    <WKVisible create={myRank}>
                        <p className="text-minor">带了<span>{myRank && myRank.count}</span>个朋友，排名第{myRank && myRank.rank}
                        </p>
                    </WKVisible>
                </div>
                <div className="weui-flex__item flex_4 text-right padding-right btn-wrap">
                    <a onClick={props.toShareCardPage} className="weui-btn weui-btn_mini weui-btn_primary"
                       id="share_card">邀请卡</a>
                </div>
            </div>
        </div>
    )
}


class DetailList extends React.Component {
    render() {
        if (this.props.list && this.props.list.length === 0) return <span className="text-minor">暂时没有成员</span>
        return (
            <div>
                <div className='content' ref={r => this.$detailList = r}>
                    <div className='clearfix'>
                        {
                            this.props.list && this.props.list.map(item => {
                                return (
                                    <li className="fl item-padding" style={{width: "25%"}} key={item.id}>
                                        <div className="portrait">
                                            <img src={item.small_avatar_url} alt=""/>
                                        </div>
                                        <p className="text-center text-ellipsis text-minor">{item.nickname}</p>
                                    </li>
                                )
                            })
                        }
                    </div>
                    {this.props.isDetailListAsking && <LoadMore loading></LoadMore>}
                </div>
                {
                    this.$detailList && <InfiniteScroll
                        el={this.$detailList}
                        onTouchBottom={() => this.props.handleTouchBottom()}
                        distance={100}
                        isStop={this.props.isDetailListAsking}
                        isKill={!this.props.detailListHasMore}
                    />
                }
            </div>
        )
    }
}

export default connect(state => ({
    account: state.account
}))(ChannelShareRankPage)


// WEBPACK FOOTER //
// ./src/pages/ChannelShareRankPage.js